import { IDmChuyenNganhActionTypes } from "../../action-types/category/IDmChuyenNganhActions";
import { IDmChuyenNganhReducer } from "../../reducer-model/category/IDmChuyenNganhReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
const iniState: IDmChuyenNganhReducer = {
  status: eReducerStatusBase.is_not_initialization,
  chuyenNganhs: [],
};
export const chuyenNganhReducer = (
  state: IDmChuyenNganhReducer = iniState,
  action: IDmChuyenNganhActionTypes
): IDmChuyenNganhReducer => {
  switch (action.type) {
    case "CHUYEN_NGANH_LOAD_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
      };
    case "CHUYEN_NGANH_LOAD_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        chuyenNganhs: action.payload,
      };
    case "CHUYEN_NGANH_LOAD_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    default:
      return state;
  }
};
